import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon, FlameIcon, GiftIcon, ArrowRightIcon, TicketIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonuses, idealFor, offerIncludes } from '../data/system';
const trust = [{
  icon: ZapIcon,
  label: 'Dijital ürüne erişim'
}, {
  icon: CreditCardIcon,
  label: 'Tek seferlik ödeme'
}, {
  icon: LockIcon,
  label: '7 günlük para iade garantisi'
}, {
  icon: SmartphoneIcon,
  label: 'Telefon, tablet ve bilgisayar'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Fiyat" className="scroll-mt-12 bg-obsidian text-white" data-id="element-197" data-mp="25shmmyvgz987">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "21px"
    }} data-id="element-198" data-mp="20slfiqrh71of">
        <div className="mx-auto max-w-xl text-center" data-id="element-199" data-mp="3h6bpuf96um6i">
          <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/40 bg-ember/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-ember" data-id="element-200" data-mp="3c8a41mkdo8rc">
            <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-201" data-mp="3vz6xzp9gm9ls" /> Sınırlı süreli teklif
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-white/75" data-id="element-202" data-mp="4v8mosgg8ni2">
            Mevcut kampanya fiyatı <span className="font-bold text-white" data-id="element-203" data-mp="9q5szrmcgir9">1.330 TRY</span>. Normal fiyat:{' '}
            <span className="line-through" data-id="element-204" data-mp="eqtkeeehj1m0">2.673 TRY</span>.{' '}
            <span className="font-semibold text-perf" data-id="element-205" data-mp="3d9qoicfsr6t8">1.343 TRY tasarruf edin.</span>
          </p>
          <p className="mt-2 text-xs leading-relaxed text-white/45" data-id="element-206" data-mp="3i790kbp4225g">
            Bu kampanyanın belirtilen bitiş süresi sona erdiğinde fiyatın hangi seviyede olacağı, gerçek kampanya koşullarına bağlıdır.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 overflow-hidden rounded-3xl border border-white/10 bg-navy shadow-[0_40px_80px_-40px_rgba(20,125,255,0.45)] lg:grid lg:grid-cols-[1fr_1.05fr]" data-id="element-207" data-mp="3rzesjlfd4jkn">
          <div className="border-b border-white/10 p-6 sm:p-8 lg:border-b-0 lg:border-r" style={{
          paddingTop: "0px"
        }} data-id="element-208" data-mp="2mh0714ycqwq1">
            <h3 className="mt-6 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-209" data-mp="318im90je0n8c">
              UZUN MESAFE TRİATLON SİSTEMİ™
            </h3>
            <p className="mt-6 text-xs font-bold uppercase tracking-[0.22em] text-aqua" data-id="element-210" data-mp="28j1wkan5jkft">Kimler için uygundur?</p>
            <ul className="mt-3 space-y-2.5" data-id="element-211" data-mp="23kgvya3zmyqu">
              {idealFor.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-white/75" data-id="element-212" data-mp="2iggdscgwgd96">
                  <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-213" data-mp="2dgty7wdlmkx7" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="p-6 sm:p-8" data-id="element-214" data-mp="3owikelj13fwy">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-215" data-mp="3ovqr5hcwlu9u">Fiyat</p>
            <div className="mt-2 flex flex-wrap items-end gap-x-3 gap-y-1" data-id="element-216" data-mp="9m1uf2r1o9m">
              <span className="font-display text-[72px] font-extrabold leading-[0.8]" data-id="element-217" data-mp="59qh61rx8cy9">1.330</span>
              <span className="pb-1 text-lg font-bold text-white/80" data-id="element-218" data-mp="3nfv4qc18gdqf">TRY</span>
              <span className="pb-1 text-xl font-medium text-white/35 line-through" data-id="element-219" data-mp="3rgexz4ioqx7a">2.673 TRY</span>
            </div>
            <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-220" data-mp="j0lhuqs9nnqr">Tek seferlik ödeme · Dijital erişim</p>
            <p className="mt-1 text-[11px] text-white/45" data-id="element-221" data-mp="nywsh3qdy2a1">Ödeme, yerel para biriminiz üzerinden gerçekleştirilecektir.</p>
            <p className="mt-1 text-[11px] text-white/45" data-id="element-222" data-mp="a81rseq1irhj">
              Gelecekteki bir abonelik ücreti olarak değil, belirtilen ürün fiyatı üzerinden tek seferlik ödeme.
            </p>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-223" data-mp="11yxtcj6nh9pi">
              Sistemin tamamında neler var?
            </p>
            <ul className="mt-3 grid gap-x-4 gap-y-2 sm:grid-cols-2" data-id="element-224" data-mp="3f7iky8xbvyok">
              {offerIncludes.map(f => <li key={f} className="flex items-start gap-2 text-sm leading-snug text-white/85" data-id="element-225" data-mp="3a8fdkhtvlgdf">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-226" data-mp="359cldxyzv4mv" />
                  {f}
                </li>)}
            </ul>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-227" data-mp="319k6z4mx649l">
              4 ücretsiz bonus
            </p>
            <ul className="mt-3 divide-y divide-white/10 border-y border-white/10" data-id="element-228" data-mp="3sz6xgdbhop62">
              {bonuses.map(b => <li key={b.n} className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-229" data-mp="3o7otrhi30ahe">
                  <span className="flex min-w-0 items-center gap-2 text-white/85" data-id="element-230" data-mp="3k74y6id5pexd">
                    <GiftIcon className="h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-231" data-mp="kj3nu20tgqf3" />
                    <span className="truncate" data-id="element-232" data-mp="fsewqnt1tvgh">{b.title}</span>
                  </span>
                  <span className="whitespace-nowrap text-xs" data-id="element-233" data-mp="fqaltlwqfw6p">
                    <span className="text-white/35 line-through" data-id="element-234" data-mp="1yggd90r0t029">{b.price}</span>{' '}
                    <span className="font-bold text-perf" data-id="element-235" data-mp="23f9h01gi9cp8">ÜCRETSİZ</span>
                  </span>
                </li>)}
            </ul>

            <div className="mt-5 rounded-xl border border-perf/25 bg-perf/10 px-4 py-3" data-id="element-236" data-mp="27eib57fgjclb">
              <p className="flex items-center gap-2 text-sm font-semibold text-white" data-id="element-237" data-mp="2cghe4g7ac7hq">
                <ShieldCheckIcon className="h-5 w-5 shrink-0 text-perf" aria-hidden="true" data-id="element-238" data-mp="2hd7uz5qwz747" />
                7 Günlük Para İade Garantisi
              </p>
              <p className="mt-1.5 text-xs leading-relaxed text-white/60" data-id="element-239" data-mp="2r42i0cbziaqp">
                İlk 7 gün içerisinde sistemin ihtiyaçlarınıza uygun olmadığına karar verirseniz, garanti koşulları kapsamında iade talebinde bulunabilirsiniz.
              </p>
            </div>

            <div className="mt-6" data-id="element-240" data-mp="302e5i5hk0sex">
              <CTAButton className="max-w-none" data-id="element-241" data-mp="35325vhroallt">Sisteme şimdi erişin</CTAButton>
            </div>
            <p className="mt-3 text-center text-xs font-semibold text-perf" data-id="element-242" data-mp="1512jjb2b8e5e">
              1.343 TRY tasarruf edin · Sınırlı süreli teklif
            </p>

            <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-243" data-mp="1042e92dabffc">
              {trust.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-244" data-mp="1a05g07485c1r">
                  <Icon className="h-4 w-4 shrink-0 text-aqua" aria-hidden="true" data-id="element-245" data-mp="1nrjzef21nf9c" />
                  {label}
                </li>)}
            </ul>

            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-ember" data-id="element-246" data-mp="1jpp0fh7l5dyq">
              <TicketIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-247" data-mp="1xphpz97dlo54" /> Teklif fiyatı: 1.330 TRY
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}